import React, { createContext, useMemo, useContext } from 'react';
import { element, string, arrayOf, oneOfType } from 'prop-types';
const Context = /*#__PURE__*/createContext(null);
Context.displayName = 'TabContext';

const useUniquePrefix = () => {
  const [id, setId] = React.useState(null);
  React.useEffect(() => {
    setId(`stereo-id-${Math.round(Math.random() * 1e5)}`);
  }, []);
  return id;
};

const TabContext = ({
  children,
  value
}) => {
  const idPrefix = useUniquePrefix();
  const context = useMemo(() => {
    return {
      idPrefix,
      value
    };
  }, [value]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: context
  }, children);
};

export const useTabContext = () => useContext(Context);
export const getPanelId = (context, value) => {
  const {
    idPrefix
  } = context;

  if (idPrefix === null) {
    return null;
  }

  return `${context.idPrefix}-P-${value}`;
};
export const getTabId = (context, value) => {
  const {
    idPrefix
  } = context;

  if (idPrefix === null) {
    return null;
  }

  return `${context.idPrefix}-T-${value}`;
};
process.env.NODE_ENV !== "production" ? TabContext.propTypes = {
  children: oneOfType([element, arrayOf(element)]),
  value: string
} : void 0;
export default TabContext;